import { createSelector } from 'reselect';

const selectProgramSubscriptions = (state: any) => state.programSubscriptions;

export const selectProgramSubscriptionsCurrentItem = createSelector([selectProgramSubscriptions], (programSubscriptions) => programSubscriptions.current);

export const selectProgramSubscriptionsListItems = createSelector([selectProgramSubscriptions], (programSubscriptions) => programSubscriptions.list);

export const selectProgramSubscriptionsItemById = (itemId: any) =>
    createSelector(selectProgramSubscriptionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectProgramSubscriptionsQueryItems = createSelector([selectProgramSubscriptions], (programSubscriptions) => programSubscriptions.query);

export const selectProgramSubscriptionsCreatedItem = createSelector([selectProgramSubscriptions], (programSubscriptions) => programSubscriptions.create);

export const selectProgramSubscriptionsUpdatedItem = createSelector([selectProgramSubscriptions], (programSubscriptions) => programSubscriptions.update);

export const selectProgramSubscriptionsReadItem = createSelector([selectProgramSubscriptions], (programSubscriptions) => programSubscriptions.read);

export const selectProgramSubscriptionsDeletedItem = createSelector([selectProgramSubscriptions], (programSubscriptions) => programSubscriptions.delete);

export const selectProgramSubscriptionsSearchedItems = createSelector([selectProgramSubscriptions], (programSubscriptions) => programSubscriptions.search);

export const selectProgramSubscriptionsItemsCount = createSelector([selectProgramSubscriptions], (programSubscriptions) => programSubscriptions.count);

export const selectProgramSubscriptionsItemsFilter = createSelector([selectProgramSubscriptions], (programSubscriptions) => programSubscriptions.filter);